import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Plus, Edit, Trash2, ChevronDown, ChevronUp } from 'lucide-react';
import { format } from 'date-fns';

const CriticalEventsCard = ({ events, onAdd, onEdit, onDelete, selectedDate }) => {
  const [showAll, setShowAll] = useState(false);
  
  // Sort events by date (most recent first)
  const sortedEvents = [...events].sort((a, b) => {
    const dateA = new Date(a.date + ' ' + a.time);
    const dateB = new Date(b.date + ' ' + b.time);
    return dateB - dateA;
  });
  
  // Show up to 3 events initially, or all if showAll is true
  const displayEvents = showAll ? sortedEvents : sortedEvents.slice(0, 3);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.15 }}
      className="p-6 rounded-xl"
      style={{ backgroundColor: '#fff5f5', border: '2px solid #F9A7A7' }}
    >
      <div className="flex items-center gap-3 mb-4">
        <button
          onClick={onAdd}
          className="btn text-sm px-3 py-1 flex items-center gap-1"
          style={{ backgroundColor: '#F9A7A7', color: 'white' }}
        >
          <Plus size={14} />
          Add
        </button>
        <h2 className="text-lg sm:text-xl font-semibold flex items-center gap-2" style={{ color: '#F9A7A7' }}>
          <AlertTriangle size={18} className="sm:w-5 sm:h-5" />
          Critical Events
        </h2>
      </div>

      {events.length === 0 ? (
        <p className="text-sm text-gray-500 text-center py-4">No critical events recorded yet</p>
      ) : (
        <>
          <div className="space-y-3">
            {displayEvents.map((event) => (
            <div
              key={event.id}
              className="p-3 rounded-lg bg-white"
              style={{ border: '1px solid #F9A7A7' }}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <p className="font-semibold text-sm" style={{ color: '#F9A7A7' }}>
                    {event.title}
                  </p>
                  <p className="text-xs text-gray-600 mt-1">
                    {format(new Date(event.date), 'MMM d, yyyy')} at {event.time}
                  </p>
                  {event.notes && (
                    <p className="text-xs text-gray-700 mt-2 italic">{event.notes}</p>
                  )}
                </div>
                <div className="flex gap-1">
                  <button
                    onClick={() => onEdit(event)}
                    className="text-blue-500 hover:text-blue-700 p-1"
                    title="Edit"
                  >
                    <Edit size={12} />
                  </button>
                  <button
                    onClick={() => onDelete(event.id)}
                    className="text-red-500 hover:text-red-700 p-1"
                    title="Delete"
                  >
                    <Trash2 size={12} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {sortedEvents.length > 3 && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="w-full text-sm py-2 rounded-lg flex items-center justify-center gap-2 mt-3"
            style={{ color: '#F9A7A7', backgroundColor: 'white', border: '1px solid #F9A7A7' }}
          >
            {showAll ? (
              <>
                <ChevronUp size={16} />
                Show Less
              </>
            ) : (
              <>
                <ChevronDown size={16} />
                Show All ({sortedEvents.length} events)
              </>
            )}
          </button>
        )}
      </>
      )}
    </motion.div>
  );
};

export default CriticalEventsCard;
